import {CancelButton, ModalBase, Text} from '../1elements'
import RejectButton from '../1elements/Buttons/TextButtons/RejectButton'
import FormTextField from './FormTextField'
import {useState} from 'react'
import {validateRejectionReason} from '../../services/util/editChecks'
import Box from '@mui/material/Box'

const RejectModal = ({open, setOpen, rejectHandler}) => {
    const [reason, setReason] = useState('')
    const [showError, setShowError] = useState(false)

    const closeHandler = () => {
        setOpen(false)
    }

    const onClickClose = () => {
        setReason('')
        setShowError(false)
        closeHandler()
    }

    const onClickReject = () => {
        setShowError(true)
        if(!validateRejectionReason(reason)){
            rejectHandler(reason)
        }
    }

    return(
        <ModalBase open={open} setOpen={setOpen} sx={{ padding: '30px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Text>Please provide reason for rejection</Text>
                <FormTextField rows={5}
                               value={reason}
                               onChange={setReason}
                               validation={showError&&validateRejectionReason(reason)}
                />
            </Box>
            <Box sx={{ display: 'flex', margin: '20px auto 0', width: '200px' }}>
                <CancelButton onClick={onClickClose} />
                <RejectButton onClick={onClickReject} />
            </Box>
        </ModalBase>
    )
}

export default RejectModal
